<template>
	<div class="btnselect" @mouseover="onselect" @mouseout="shutselect">
		<button class="btn subbtn btnLass">{{name}} <i class="el-icon-arrow-down"></i></button>
		<div class="select" v-if="selectshow">
			<div v-for="(v,k) in list" :key="k" :data-permissions="v.btnPermissions" v-has>
				<p :class="v.border?'borbtm':''" @click="clickselect(v.action)" v-if="!v.url">{{v.name}}</p>
			</div>
			<router-link :to="v.url" tag="p" :class="v.border?'borbtm':''" v-for="(v,k) in list" :key="k" v-if="v.url"  :data-permissions="v.btnPermissions" v-has>
				{{v.name}}
			</router-link>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				selectshow:false
			}
		},
		props: {
			name: "",
			list:"",
			type:""
		},
		methods: {
			onselect(){
				this.selectshow = true;
			},
			shutselect(){
				this.selectshow = false;				
			},
			clickselect(a){
				this.$emit(a);
				this.shutselect();
			}
		}
	}
</script>

<style scoped lang="less">
	.btnselect{
		position: relative;
    .btnLass{
      background-color: #fff;
      color: #6669e3;
    }
		button{
			/*display: flex;
			align-items: center;*/
			i{
				margin-left: 5px;
			}
		}
	}
	.select {
		position: absolute;
		width: 100%;
		left: 0;
		top: 34px;
		box-sizing: border-box;
		background-color: #fff;
		border: 1px solid #dadce8;
		color: #545566;
		border-radius: 6px;
		z-index: 100;
		overflow: hidden;
		font-size: 14px;
		box-shadow: 2px 2px 6px rgba(222, 225, 228, 0.2), 2px -2px 6px rgba(222, 225, 228, 0.2), -2px 2px 6px rgba(222, 225, 228, 0.2), -2px -2px 6px rgba(222, 225, 228, 0.2);
		p {
			width: 100%;
			text-align: center;
			height: 38px;
			line-height: 38px;
			cursor: pointer;
		}
		.borbtm{
			box-sizing:border-box;
		}
		.borbtm:after{
			content:'';
			display: block;
			margin: 0 auto;
			width: 90%;
			height: 1px;
			background-color: #e9eff4;
		}
		p:hover {
			background-color: #f2f5f8;
		}
	}
</style>
